/* Arrow controls for the horizontal rails. Delegated, so it also covers
   sections re-rendered by the theme editor. Mirrors the design's nudge():
   scroll by one card width plus the gap. */
(function () {
  if (window.__nbRailInit) return;
  window.__nbRailInit = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nb-arw]');
    if (!btn) return;
    var root = btn.closest('[data-nb-root]');
    if (!root) return;
    // The rail nearest the button, preferring a visible one (audit 2026-09-24:
    // the mega menu, tablet drawer and brand-page tabs hold several rails, and
    // the first one in the section is usually a hidden pane).
    var rail = null;
    for (var el = btn.parentElement; el && !rail; el = el === root ? null : el.parentElement) {
      var rails = el.querySelectorAll('[data-nb-rail]');
      for (var i = 0; i < rails.length && !rail; i++) if (rails[i].offsetWidth > 0) rail = rails[i];
      if (!rail && rails.length) rail = rails[0];
    }
    if (!rail) return;
    var dir = btn.getAttribute('data-nb-arw') === 'prev' ? -1 : 1;
    var card = Array.prototype.slice.call(rail.children).filter(function (c) {
      return c.offsetWidth > 80;
    })[0];
    var gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
    var step = card ? card.offsetWidth + gap : rail.clientWidth * 0.5;
    rail.scrollBy({ left: dir * step, behavior: 'smooth' });
  });
})();

/* Every CSS-only toggle here (collection tabs, menu items, the drawer's own
   open/close) is a hidden radio or checkbox driven by a <label>. Clicking the
   label focuses that input, and the browser scrolls it into view — which yanks
   the page, sometimes thousands of pixels. Set the input directly instead, so
   nothing takes focus. Without JS the labels still work natively. */
(function () {
  if (window.__nbTabInit) return;
  window.__nbTabInit = true;
  document.addEventListener('click', function (e) {
    var lab = e.target.closest && e.target.closest('label[for]');
    if (!lab) return;
    var input = document.getElementById(lab.getAttribute('for'));
    if (!input || !input.classList.contains('nb-radio')) return;
    e.preventDefault();
    if (input.type === 'checkbox') input.checked = !input.checked;
    else if (input.checked) return;
    else input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

/* Always-visible scroll indicators.
   iOS and macOS render overlay scrollbars that appear only while scrolling, and
   no CSS overrides that (scrollbar-gutter is spec'd not to apply to overlay
   bars). So the native ones are hidden and these are drawn instead: a faint
   track plus a thumb sized and positioned from the element's own scroll state.
   The track is absolutely positioned inside the scroller and offset by the
   scroll position, which keeps it pinned to the visible area.

   Scoped measuring (mobile audit 2026-09-22, item 10). This used to re-measure
   every [data-nb-sb] on the page (34+, nearly all in closed menu panes) on
   every change event, several times over (2 frames, 160ms, 600ms, 1.4s), each
   element read-then-write. Now:
   - a ResizeObserver on each scroller and its direct children says when one
     changed size or went hidden/shown; hidden ones (display:none, zero size,
     closed menu panes) are never read;
   - a childList MutationObserver per scroller picks up swapped content;
   - work is queued and done at most once per animation frame, all reads first,
     then all writes, and only when the numbers actually changed;
   - browsers without ResizeObserver keep the old timed passes, but coalesced.
   The styles written are the same as before, so every indicator looks the same. */
(function () {
  if (window.__nbSbInit) return;
  window.__nbSbInit = true;

  var RO = typeof ResizeObserver === 'function' ? new ResizeObserver(onResize) : null;
  var MO = typeof MutationObserver === 'function' ? new MutationObserver(onMutate) : null;
  var all = [];        // every scroller built so far
  var queue = [];      // scrollers waiting for the next frame
  var raf = 0;

  function build(sc) {
    if (sc.__nbSb) return;
    var axis = sc.getAttribute('data-nb-sb') === 'x' ? 'x' : 'y';
    var track = document.createElement('span');
    track.className = 'nb-sb nb-sb--' + axis;
    var thumb = document.createElement('i');
    thumb.className = 'nb-sb__t';
    track.appendChild(thumb);
    sc.appendChild(track);
    // shown: unknown until the first ResizeObserver entry (without RO, always measured)
    sc.__nbSb = { track: track, thumb: thumb, axis: axis, last: '', shown: !RO, q: false, settle: 0 };
    all.push(sc);
    if (RO) { RO.observe(sc); watchKids(sc); }
    if (MO) MO.observe(sc, { childList: true });
  }

  // The scroll length changes when a child changes size (images, fonts, a tab
  // swapping panes) even though the scroller itself does not, so watch those too.
  function watchKids(sc) {
    var k = sc.children;
    for (var i = 0; i < k.length; i++) if (k[i] !== sc.__nbSb.track) RO.observe(k[i]);
  }

  // Read phase: returns null for a hidden scroller, so it is left alone.
  function measure(sc) {
    var o = sc.__nbSb, vert = o.axis === 'y';
    var w = sc.clientWidth, h = sc.clientHeight;
    if (!w || !h) return null;
    return {
      view:  vert ? h : w,
      total: vert ? sc.scrollHeight : sc.scrollWidth,
      pos:   vert ? sc.scrollTop : sc.scrollLeft
    };
  }

  // Write phase: identical styles to the old update(); skipped when nothing moved.
  // Returns true when the size (not just the position) changed.
  function apply(sc, m) {
    var o = sc.__nbSb;
    var key = m.view + ',' + m.total + ',' + m.pos;
    if (key === o.last) return false;
    var sizeChanged = o.last.slice(0, o.last.lastIndexOf(',')) !== m.view + ',' + m.total;
    o.last = key;
    var view = m.view, total = m.total, pos = m.pos, vert = o.axis === 'y';
    if (total - view < 16) { o.track.style.display = 'none'; return sizeChanged; }  // barely scrollable: no cue needed
    o.track.style.display = 'block';
    var size  = Math.max(28, view * view / total);
    var range = view - size;
    var frac  = (total - view) > 0 ? pos / (total - view) : 0;
    if (vert) {
      o.track.style.top = pos + 'px';
      o.track.style.height = view + 'px';
      o.thumb.style.height = size + 'px';
      o.thumb.style.transform = 'translateY(' + (range * frac) + 'px)';
    } else {
      o.track.style.left = pos + 'px';
      o.track.style.width = view + 'px';
      o.thumb.style.width = size + 'px';
      o.thumb.style.transform = 'translateX(' + (range * frac) + 'px)';
    }
    return sizeChanged;
  }

  // One batched pass: all reads, then all writes. Where the track is not
  // absolutely positioned (the PDP thumbs have no .nb-sb CSS, so it sits in the
  // flex row), writing it changes the scroll length, so a scroller whose size
  // changed is checked once more next frame until it is stable (max 3 times).
  function run(list) {
    var ms = [], i;
    for (i = 0; i < list.length; i++) ms.push(list[i].__nbSb.shown ? measure(list[i]) : null);
    for (i = 0; i < list.length; i++) {
      var sc = list[i], o = sc.__nbSb;
      if (!ms[i]) { o.settle = 0; continue; }
      if (apply(sc, ms[i]) && o.settle < 3) { o.settle++; queueOne(sc); }
      else o.settle = 0;
    }
  }

  function flush() {
    raf = 0;
    var list = queue; queue = [];
    for (var i = 0; i < list.length; i++) list[i].__nbSb.q = false;
    run(list);
  }
  function queueOne(sc) {
    if (!sc.__nbSb || sc.__nbSb.q) return;
    sc.__nbSb.q = true;
    queue.push(sc);
    if (!raf) raf = requestAnimationFrame(flush);
  }
  function queueShown() {
    for (var i = 0; i < all.length; i++) if (all[i].__nbSb.shown) queueOne(all[i]);
  }

  // ResizeObserver runs after layout and before paint, so these are measured
  // in the same frame they change: a pane that opens never shows a stale bar.
  function onResize(entries) {
    var hit = [], i, t, sc;
    for (i = 0; i < entries.length; i++) {          // the scrollers' own entries first: shown/hidden
      t = entries[i].target;
      if (t.__nbSb) { var r = entries[i].contentRect; t.__nbSb.shown = r.width > 0 && r.height > 0; }
    }
    for (i = 0; i < entries.length; i++) {
      t = entries[i].target;
      sc = t.__nbSb ? t : t.parentNode;
      if (sc && sc.__nbSb && !sc.__nbSb.q && hit.indexOf(sc) < 0) hit.push(sc);
    }
    run(hit);
  }

  function onMutate(recs) {
    for (var i = 0; i < recs.length; i++) {
      var sc = recs[i].target;
      if (!sc.__nbSb) continue;
      if (RO) watchKids(sc);
      queueOne(sc);
    }
  }

  function scan() {
    var list = document.querySelectorAll('[data-nb-sb]');
    for (var i = 0; i < list.length; i++) build(list[i]);
    queueShown();
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.__nbSb || !t.__nbSb.shown) return;
    var m = measure(t);              // scroll events already come once per frame
    if (m) apply(t, m);
  }, true);
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);   // theme editor re-render
  document.addEventListener('change', function () { rescan(); });

  // Called by the menu when it opens (sections/newbrand-menu.liquid). With
  // ResizeObserver the opening panes report themselves; this only picks up new
  // scrollers and re-checks the ones already on screen. Without it, the old
  // timed passes: after paint and again once images have settled.
  function rescan() {
    scan();
    if (RO) return;
    setTimeout(queueShown, 160);
    setTimeout(queueShown, 600);
  }
  window.__nbScanScrollbars = rescan;
  scan();
  if (!RO) {
    window.addEventListener('resize', queueShown);
    rescan();
    setTimeout(queueShown, 1400);
  }
})();

/* Mega-menu rail: switch on hover, as the design's own note says ("Hover a
   name to load its categories, types and collections"). Only on devices that
   actually hover, so a tap on touch still behaves like a tap. */
(function () {
  if (window.__nbHoverInit) return;
  window.__nbHoverInit = true;
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
  document.addEventListener('mouseover', function (e) {
    var lab = e.target.closest && e.target.closest('label[data-nb-hover]');
    if (!lab) return;
    var input = document.getElementById(lab.getAttribute('for'));
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
